import type { ITreeNode } from '@platform/core/types';
import type { IPickerOption } from '@platform/ui';
import type { ITreeOptionText } from './ITreeOptionText';
import { orderTree } from './orderTree';

/**
 * Пункти дерева напрямів або ітерацій (UIUX/controls/tree-picker; прототип fieldItems): відступ 16px на рівень; напрями — корінь 700,
 * решта 500, крапка кольору найближчого предка з кольором; ітерації — рівні 0–1 700, 2 — 600, глибше 500, листки з датами —
 * уточнення «7 вер. – 20 вер.», бейдж «Поточний» на найглибшому вузлі, що містить сьогодні, минулі листки приглушені.
 */
export function treeOptions(nodes: ITreeNode[], kind: 'area' | 'iteration', today: string, text: ITreeOptionText): IPickerOption[] {
  const ordered = orderTree(nodes);
  const byId = new Map(nodes.map((n) => [n.id, n]));
  const colourOf = (n: ITreeNode | undefined): string => (!n ? '' : n.color || colourOf(n.parentId ? byId.get(n.parentId) : undefined));
  const hasChildren = new Set(nodes.map((n) => n.parentId).filter(Boolean));
  const containing = ordered.filter((o) => o.node.startDate && o.node.endDate && o.node.startDate <= today && today <= o.node.endDate);
  const current = containing.reduce<(typeof ordered)[number] | undefined>((best, o) => (!best || o.depth > best.depth ? o : best), undefined);
  return ordered.map(({ node: n, depth }) => {
    if (kind === 'area') return { value: n.id, label: n.name, indent: depth, weight: depth === 0 ? 700 : 500, dot: colourOf(n) };
    const leaf = !hasChildren.has(n.id);
    const dated = leaf && n.startDate && n.endDate;
    return {
      value: n.id, label: n.name, indent: depth, weight: depth <= 1 ? 700 : depth === 2 ? 600 : 500,
      ...(dated ? { sub: text.range(n.startDate!, n.endDate!) } : {}),
      ...(current?.node.id === n.id && depth > 0 ? { badge: text.current } : {}),
      ...(dated && n.endDate! < today ? { muted: true } : {}),
    };
  });
}
